import React, { useState, useRef } from 'react'
import classnames from 'classnames'
import dayjs from 'dayjs'
import plural from 'plural-ru'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import FeaturesList from './FeaturesList'
import SubscriptionManagementSelect from './SubscriptionManagementSelect'
import Button from './Button'
import Spinner from './Spinner'
import { profileSelector } from '../reducers/profile'
import products_new from '../constants/ProductsNew'
import { patchSubscription } from '../actions/api'
import { getDiscountsSelector } from '../reducers/discounts'
import { setDiscounts } from '../actions/utils'
import find from 'lodash/find'
import get from 'lodash/get'

import '../styles/subscription.scss'

function Subscription({
  profile,
  id,
  kind,
  lastPaymentProduct,
  type,
  product,
  active,
  promoCode,
  expiresAt,
  cancelledAt,
  delayedDurationDays,
  withSelect,
  patchSubscription,
  currency,
  priceCents,
  nextPriceCents,
  extraTipCents,
  introductoryPriceCents,
  initIsSubscriptionManagement,
  resumingUnavailable,
  index
}) {
  const [loading, setLoading] = useState(false)
  const yourSubscriptionEl = useRef(null)
  const [isSubscriptionManagement, setSubscriptionManagement] = useState(initIsSubscriptionManagement)
  const [differentProducts, setDifferentProducts] = useState(false)

  const formattedExpiresAt = dayjs.unix(expiresAt).format('DD.MM.YYYY')
  const lastPaymentProductDetails = find(products_new, { product: lastPaymentProduct })
  const oldPrice = (priceCents || 0) / 100
  const effectivePrice = ((introductoryPriceCents ? introductoryPriceCents : priceCents) || 0) / 100
  const effectivePriceWithCurrency = currency === 'RUB' ? `${effectivePrice} ₽` : `${currency} ${effectivePrice}`
  const isPaidTrialOrIntroductorySubscription = Boolean(introductoryPriceCents)
  const isLifetime = lastPaymentProductDetails?.product.includes('lifetime')
  const priceWithoutTipCents = (priceCents || 0) - extraTipCents
  const nextPriceWithoutTipCents = (nextPriceCents || 0) - extraTipCents
  const currencySign = currency === 'RUB' ? '₽' : currency
  return (
    <div className={classnames('account-block')}>
      {/* Рендерим только один раз */}
      {active && !index && (
        <div className="account-title" ref={yourSubscriptionEl}>
          Ваша подписка
        </div>
      )}

      <div className="account-wrapper account-wrapper--management account-wrapper--kids account-wrapper--new" id={type}>
        {/*{id}*/}
        {/* ВЕРХНИЙ БЕЙДЖ*/}
        {kind && renderTopBadge()}
        {/**/}
        {/* ЛОГО */}
        {(isLifetime || expiresAt) && renderLogo()}
        {(isLifetime || expiresAt) && (
          <div
            className={classnames('account-subscription__header', {
              'account-subscription__header--column': kind === 'apple_subscription' || kind === 'google_subscription'
            })}>
            {kind !== 'promo_subscription' && renderPrice()}
            {promoCode && (
              <div className="account-subscription__data">
                <span className="account-subscription__label">
                  Промокод{' '}
                  {delayedDurationDays &&
                    delayedDurationDays < 36500 &&
                    `на ${delayedDurationDays} ${plural(delayedDurationDays, 'день', 'дня', 'дней')}`}
                  {delayedDurationDays && delayedDurationDays >= 36500 && `на вечную подписку`}
                </span>
                <span className="account-subscription__value">{promoCode}</span>
              </div>
            )}
            {isLifetime && (
              <div className="account-subscription__data">
                <span className="account-subscription__label">Подписка</span>
                <span className="account-subscription__value">Навсегда</span>
              </div>
            )}
            {/* ПРАВЫЙ ТЕКСТ */}
            {!isLifetime && renderDate()}
          </div>
        )}
        {/* Включить автопродление */}
        {kind === 'web_subscription' && Boolean(cancelledAt) && (
          <div className="account-subscription__wrap-button">
            <Button onClick={handleResumeCancelledClick} disabled={loading || resumingUnavailable} isSubscription>
              {loading ? <Spinner /> : 'Включить автопродление'}
            </Button>
            {resumingUnavailable && (
              <div className="account-subscription__auto-renewal-text">
                Автопродление подписки не работает при оплате картами иностранных банков
              </div>
            )}
          </div>
        )}
        {/**/}
        {/* Управление подпиской */}
        {kind === 'web_subscription' &&
          !isLifetime &&
          !Boolean(cancelledAt) &&
          !isSubscriptionManagement &&
          renderAttention()}
        {/**/}
        {/* ПОЯВЛЯЕТСЯ ЕСЛИ НАЖАТЬ НА Управление подпиской */}
        {(withSelect || isSubscriptionManagement) && (
          <div className="account-subscription__wrap-subscription-select">
            <SubscriptionManagementSelect
              id={id}
              type={type}
              activeProduct={product}
              withPay={differentProducts}
              onProductChange={handleProductChange}
              setSubscriptionManagement={setSubscriptionManagement}
            />
          </div>
        )}
        {/**/}
        {/* КНОПКА ОТМЕНИТЬ ПОДПИСКУ*/}
        {isSubscriptionManagement && renderCancelSubscription()}
        {/**/}
        {/**/}
        {/* Если подписка есть и она общая ВЫВОДИТ Особенности*/}
        {product && product === 'pack_yearly' && <FeaturesList />}
        {/**/}
        {/**/}
        {kind === 'apple_subscription' && renderAppleSubscription()}
        {/**/}
        {/**/}
        {kind === 'google_subscription' && renderGoogleSubscription()}
        {/**/}
        {/**/}
      </div>
    </div>
  )

  function renderTopBadge() {
    return (
      <div
        className={classnames('account-subscription__badge', {
          'account-subscription__badge--inactive': active && Boolean(cancelledAt)
        })}>
        {active ? (Boolean(cancelledAt) ? 'Подписка без продления' : 'Ура, все работает!') : 'Еще не активна'}
      </div>
    )
  }

  function renderLogo() {
    return (
      <div className="account-subscription__logo">
        {type === 'pack' && (
          <svg xmlns="http://www.w3.org/2000/svg" width="249" height="28" viewBox="0 0 249 28" fill="none">
            <path
              d="M154.001 0.525031C154.001 0.238014 153.763 0 153.476 0C153.189 0 152.951 0.238014 152.951 0.532032C152.951 7.34343 147.343 12.9508 140.532 12.9508C140.238 12.9508 140 13.1888 140 13.4758C140 13.7628 140.238 14.0008 140.525 14.0008H152.951C153.532 14.0008 154.001 13.5318 154.001 12.9508V0.525031Z"
              fill="black"
            />
            <path
              d="M167.474 13.999H155.048C154.467 13.999 153.998 14.4681 153.998 15.0491V27.4748C153.998 27.7618 154.236 27.9999 154.523 27.9999C154.81 27.9999 155.048 27.7618 155.048 27.4678C155.048 20.6564 160.655 15.0491 167.467 15.0491C167.754 15.0491 167.999 14.8111 167.999 14.5241C167.999 14.237 167.761 13.999 167.474 13.999Z"
              fill="black"
            />
            <path d="M187.934 8.99479V6.80273H180.057V19.3893H182.337V8.99479H187.934Z" fill="black" />
            <path
              d="M195.882 10.4444H193.738L192.122 16.9498H192.087L190.233 10.4444H188.004L190.849 18.874C191.011 19.3529 191.069 19.9784 190.635 20.2372C190.466 20.3378 190.25 20.3793 189.944 20.3793C189.569 20.3793 189.331 20.3439 189.127 20.3086V22.2355C189.501 22.3062 189.859 22.3592 190.369 22.3592C191.866 22.3592 192.581 21.8289 193.057 20.1848L195.882 10.4444Z"
              fill="black"
            />
            <path
              d="M204.975 16.8614L203.205 15.8891C202.882 16.7023 202.355 17.6216 201.113 17.6216C199.666 17.6216 199.003 16.3134 199.003 14.9168C199.003 13.5203 199.751 12.2121 201.232 12.2121C202.048 12.2121 202.78 12.7602 203.052 13.644L204.873 12.7778C204.345 11.4343 203.324 10.2322 201.232 10.2322C198.441 10.2322 196.825 12.2475 196.825 14.9168C196.825 17.5862 198.441 19.6015 201.079 19.6015C203.409 19.6015 204.396 18.1696 204.975 16.8614Z"
              fill="black"
            />
            <path
              d="M213.977 16.4371C213.977 14.7047 212.735 13.5203 210.983 13.5203H208.737V10.4444H206.661V19.3893H210.881C212.939 19.3893 213.977 18.1519 213.977 16.4371ZM211.816 16.3311C211.816 17.2503 211.391 17.5155 210.659 17.5155H208.737V15.3588H210.71C211.51 15.3588 211.816 15.73 211.816 16.3311Z"
              fill="black"
            />
            <path d="M221.52 12.3182V10.4444H215.803V19.3893H217.879V12.3182H221.52Z" fill="black" />
            <path
              d="M230.41 10.4444H228.266L226.65 16.9498H226.616L224.761 10.4444H222.532L225.377 18.874C225.539 19.3529 225.597 19.9784 225.163 20.2372C224.994 20.3378 224.778 20.3793 224.472 20.3793C224.097 20.3793 223.859 20.3439 223.655 20.3086V22.2355C224.029 22.3062 224.387 22.3592 224.897 22.3592C226.394 22.3592 227.109 21.8289 227.585 20.1848L230.41 10.4444Z"
              fill="black"
            />
            <path
              d="M239.503 16.8614L237.733 15.8891C237.41 16.7023 236.883 17.6216 235.641 17.6216C234.194 17.6216 233.531 16.3134 233.531 14.9168C233.531 13.5203 234.279 12.2121 235.76 12.2121C236.576 12.2121 237.308 12.7602 237.58 13.644L239.401 12.7778C238.873 11.4343 237.852 10.2322 235.76 10.2322C232.969 10.2322 231.353 12.2475 231.353 14.9168C231.353 17.5862 232.969 19.6015 235.607 19.6015C237.937 19.6015 238.924 18.1696 239.503 16.8614Z"
              fill="black"
            />
            <path
              d="M248.505 16.4371C248.505 14.7047 247.263 13.5203 245.511 13.5203H243.265V10.4444H241.189V19.3893H245.409C247.467 19.3893 248.505 18.1519 248.505 16.4371ZM246.344 16.3311C246.344 17.2503 245.919 17.5155 245.187 17.5155H243.265V15.3588H245.238C246.038 15.3588 246.344 15.73 246.344 16.3311Z"
              fill="black"
            />
            <path
              d="M10.7184 19.4112L5.99933 6H3.29593L2.42586 8.48206L6.20494 19.4112C6.43386 20.0949 6.36498 20.7544 4.89933 20.7544V21.6657H12.2742V20.7544C11.6563 20.7544 11.0607 20.4131 10.7184 19.4112Z"
              fill="black"
            />
            <path
              d="M20.202 20.7111H20.6933V21.6647H13.2374V20.8441C13.5271 20.8219 13.7732 20.7776 13.9748 20.6668C14.3091 20.4896 14.4883 20.1342 14.4883 19.6015V12.9004C14.4883 12.1463 14.3769 11.9237 13.439 11.9459C13.283 11.9459 13.126 11.9459 12.9254 11.968V11.1917C13.9525 10.8141 15.9611 10.2371 17.2555 10.2371C18.4609 10.2371 18.7516 10.6369 18.7516 11.6569V12.256C19.7786 10.9249 20.8726 10.2371 22.0992 10.2371C23.2376 10.2371 24.131 10.947 24.131 12.1896C24.131 13.3878 23.3278 14.1641 22.2784 14.1641C20.8503 14.1641 20.984 12.6115 19.7118 12.6115C19.5781 12.6115 19.2651 12.6336 18.7526 12.9004V19.6015C18.7516 20.2449 19.2418 20.7111 20.202 20.7111Z"
              fill="black"
            />
            <path
              d="M25.6503 10.5714H35.1816L35.5614 11.1927L29.713 20.4453H31.5656C33.0616 20.4453 34.3338 19.4021 34.8028 17.8938L35.5614 17.9824L35.0702 21.6657H24.9818L24.6476 21.0887L30.495 11.7918H28.843C26.9904 11.7918 26.2095 12.9679 25.7405 14.1883L24.915 14.0775L25.6503 10.5714Z"
              fill="black"
            />
            <path
              d="M48.4859 20.6447C48.5973 20.6668 48.731 20.6447 48.888 20.6447L48.9103 21.1552C48.3076 21.4875 47.1246 21.998 45.6518 21.998C43.5764 21.998 43.1297 21.0877 43.1297 19.8019V19.5572C42.3924 20.7997 41.2539 21.9758 39.4692 21.9758C37.7726 21.9758 36.7901 20.9105 36.7901 19.3357C36.7901 17.2272 38.5312 16.5173 40.8082 16.0521L43.1297 15.5859V15.1862C43.1297 13.8772 42.6385 13.0122 40.9642 13.0122C40.0485 13.0122 38.7105 13.2116 37.2145 13.567V11.9912C39.1116 10.9702 41.2549 10.2381 43.0629 10.2381C46.2322 10.2381 47.393 11.969 47.393 14.9203V19.2692C47.392 20.3567 47.6381 20.6447 48.4859 20.6447ZM43.1297 19.0245V16.473L41.969 16.762C41.188 16.9614 40.6076 17.2947 40.6076 18.0931C40.6076 18.9581 41.2994 19.2471 41.969 19.2471C42.3478 19.2471 42.7499 19.1585 43.1297 19.0245Z"
              fill="black"
            />
            <path
              d="M55.7422 20.6447C55.9428 20.7554 56.1656 20.8219 56.4563 20.8441V21.6647H49.6932V20.8441C49.9829 20.8219 50.2291 20.7776 50.4296 20.6668C50.7639 20.4896 50.9431 20.1342 50.9431 19.6015V12.9004C50.9431 12.1684 50.8317 11.9459 50.0052 11.9459C49.8269 11.9459 49.6264 11.9459 49.3803 11.968V11.1917C50.4073 10.8141 52.4159 10.2371 53.7104 10.2371C54.9157 10.2371 55.2064 10.6369 55.2064 11.6569V12.4775C56.3894 11.1907 57.8632 10.2361 59.5588 10.2361C61.4559 10.2361 62.4607 11.0125 62.8172 12.5883C64.0448 11.2571 65.5186 10.2361 67.281 10.2361C69.7585 10.2361 70.7188 11.5451 70.7188 14.297V19.6005C70.7188 20.1332 70.9193 20.4433 71.2535 20.6437C71.4551 20.7544 71.678 20.8209 71.9676 20.843V21.6637H65.2046V20.843C65.4943 20.8209 65.7404 20.7766 65.941 20.6658C66.2752 20.4886 66.4545 20.1332 66.4545 19.6005V15.5194C66.4545 13.8107 66.1871 12.6346 64.4682 12.6346C63.9324 12.6346 63.4857 12.7011 62.8841 12.9669C62.9509 13.3666 62.9955 13.8107 62.9955 14.298V19.6015C62.9955 20.1342 63.196 20.4443 63.5303 20.6447C63.7318 20.7554 63.9547 20.8219 64.2444 20.8441V21.6647H57.4813V20.8441C57.771 20.8219 58.0171 20.7776 58.2177 20.6668C58.552 20.4896 58.7312 20.1342 58.7312 19.6015V15.5194C58.7312 13.8107 58.4638 12.6346 56.745 12.6346C56.2314 12.6346 55.7858 12.7011 55.2044 12.9447V19.6015C55.2064 20.1342 55.408 20.4453 55.7422 20.6447Z"
              fill="black"
            />
            <path
              d="M84.651 20.6447C84.7624 20.6668 84.8961 20.6447 85.0531 20.6447L85.0754 21.1552C84.4727 21.4875 83.2897 21.998 81.8169 21.998C79.7415 21.998 79.2949 21.0877 79.2949 19.8019V19.5572C78.5575 20.7997 77.419 21.9758 75.6343 21.9758C73.9377 21.9758 72.9552 20.9105 72.9552 19.3357C72.9552 17.2272 74.6964 16.5173 76.9733 16.0521L79.2949 15.5859V15.1862C79.2949 13.8772 78.8036 13.0122 77.1293 13.0122C76.2137 13.0122 74.8756 13.2116 73.3796 13.567V11.9912C75.2767 10.9702 77.42 10.2381 79.228 10.2381C82.3973 10.2381 83.5581 11.969 83.5581 14.9203V19.2692C83.5571 20.3567 83.8032 20.6447 84.651 20.6447ZM79.2938 19.0245V16.473L78.1331 16.762C77.3521 16.9614 76.7718 17.2947 76.7718 18.0931C76.7718 18.9581 77.4636 19.2471 78.1331 19.2471C78.5129 19.2471 78.914 19.1585 79.2938 19.0245Z"
              fill="black"
            />
            <path
              d="M86.0144 21.2216L85.9475 18.0267L86.8621 17.9159C87.6654 19.6468 88.8038 20.8008 90.3444 20.8008C91.4161 20.8008 92.0187 20.1795 92.0187 19.4475C92.0187 18.6711 91.2824 18.3378 90.3444 18.0941L89.3407 17.8273C87.8223 17.4276 86.1268 16.3632 86.1268 14.3212C86.1268 11.9026 88.4483 10.2381 91.6176 10.2381C92.8453 10.2381 94.2066 10.4828 95.2782 11.0819L95.501 13.9225L94.4294 13.9889C93.4479 12.0365 92.4209 11.4374 91.3269 11.4374C90.3677 11.4374 89.8755 12.0365 89.8755 12.7464C89.8755 13.6123 90.5227 14.0111 91.3938 14.2336L92.6214 14.5447C94.0941 14.9223 95.8799 15.6765 95.8799 17.8283C95.8799 20.7575 92.6437 22 89.9423 22C88.6489 21.998 87.1751 21.71 86.0144 21.2216Z"
              fill="black"
            />
            <path
              d="M99.2973 18.1485C98.2257 18.1485 97.0427 17.6159 97.0427 16.1296C97.0427 14.6424 98.2257 14.0886 99.2973 14.0886C100.346 14.0886 101.551 14.6434 101.551 16.1296C101.552 17.6159 100.347 18.1485 99.2973 18.1485Z"
              fill="black"
            />
            <path
              d="M2.10275 18.3821C1.03112 18.3821 0 17.8495 0 16.3632C0 14.876 1.03112 14.3222 2.10275 14.3222C3.15109 14.3222 4.21665 14.877 4.21665 16.3632C4.21665 17.8495 3.15109 18.3821 2.10275 18.3821Z"
              fill="black"
            />
            <path
              d="M119.51 12.51H113V14.7H119.51V21.21H121.7V14.7H128.24V12.51H121.7V6H119.51V12.51Z"
              fill="#1A1A1A"
            />
          </svg>
        )}
        {type === 'radio' && (
          <svg xmlns="http://www.w3.org/2000/svg" width="102" height="16" viewBox="0 0 102 16" fill="none">
            <path
              d="M10.7184 13.4112L5.99933 0H3.29593L2.42586 2.48206L6.20494 13.4112C6.43386 14.0949 6.36498 14.7544 4.89933 14.7544V15.6657H12.2742V14.7544C11.6563 14.7544 11.0607 14.4131 10.7184 13.4112Z"
              fill="black"
            />
            <path
              d="M20.202 14.7111H20.6933V15.6647H13.2374V14.8441C13.5271 14.8219 13.7732 14.7776 13.9748 14.6668C14.3091 14.4896 14.4883 14.1342 14.4883 13.6015V6.90044C14.4883 6.14626 14.3769 5.92373 13.439 5.94588C13.283 5.94588 13.126 5.94588 12.9254 5.96803V5.19169C13.9525 4.8141 15.9611 4.23713 17.2555 4.23713C18.4609 4.23713 18.7516 4.63688 18.7516 5.65689V6.25601C19.7786 4.92486 20.8726 4.23713 22.0992 4.23713C23.2376 4.23713 24.131 4.94701 24.131 6.18955C24.131 7.38779 23.3278 8.16413 22.2784 8.16413C20.8503 8.16413 20.984 6.61145 19.7118 6.61145C19.5781 6.61145 19.2651 6.63361 18.7526 6.90044V13.6015C18.7516 14.2449 19.2418 14.7111 20.202 14.7111Z"
              fill="black"
            />
            <path
              d="M25.6503 4.57143H35.1816L35.5614 5.1927L29.713 14.4453H31.5656C33.0616 14.4453 34.3338 13.4021 34.8028 11.8938L35.5614 11.9824L35.0702 15.6657H24.9818L24.6476 15.0887L30.495 5.79182H28.843C26.9904 5.79182 26.2095 6.9679 25.7405 8.1883L24.915 8.07753L25.6503 4.57143Z"
              fill="black"
            />
            <path
              d="M48.4859 14.6447C48.5973 14.6668 48.731 14.6447 48.888 14.6447L48.9103 15.1552C48.3076 15.4875 47.1246 15.998 45.6518 15.998C43.5764 15.998 43.1297 15.0877 43.1297 13.8019V13.5572C42.3924 14.7997 41.2539 15.9758 39.4692 15.9758C37.7726 15.9758 36.7901 14.9105 36.7901 13.3357C36.7901 11.2272 38.5312 10.5173 40.8082 10.0521L43.1297 9.5859V9.18616C43.1297 7.87716 42.6385 7.01221 40.9642 7.01221C40.0485 7.01221 38.7105 7.21158 37.2145 7.56702V5.99119C39.1116 4.97017 41.2549 4.23814 43.0629 4.23814C46.2322 4.23814 47.393 5.96904 47.393 8.92033V13.2692C47.392 14.3567 47.6381 14.6447 48.4859 14.6447ZM43.1297 13.0245V10.473L41.969 10.762C41.188 10.9614 40.6076 11.2947 40.6076 12.0931C40.6076 12.9581 41.2994 13.2471 41.969 13.2471C42.3478 13.2471 42.7499 13.1585 43.1297 13.0245Z"
              fill="black"
            />
            <path
              d="M55.7422 14.6447C55.9428 14.7554 56.1656 14.8219 56.4563 14.8441V15.6647H49.6932V14.8441C49.9829 14.8219 50.2291 14.7776 50.4296 14.6668C50.7639 14.4896 50.9431 14.1342 50.9431 13.6015V6.90044C50.9431 6.16841 50.8317 5.94588 50.0052 5.94588C49.8269 5.94588 49.6264 5.94588 49.3803 5.96803V5.19169C50.4073 4.8141 52.4159 4.23713 53.7104 4.23713C54.9157 4.23713 55.2064 4.63688 55.2064 5.65689V6.47753C56.3894 5.19069 57.8632 4.23612 59.5588 4.23612C61.4559 4.23612 62.4607 5.01246 62.8172 6.58829C64.0448 5.25714 65.5186 4.23612 67.281 4.23612C69.7585 4.23612 70.7188 5.54512 70.7188 8.29704V13.6005C70.7188 14.1332 70.9193 14.4433 71.2535 14.6437C71.4551 14.7544 71.678 14.8209 71.9676 14.843V15.6637H65.2046V14.843C65.4943 14.8209 65.7404 14.7766 65.941 14.6658C66.2752 14.4886 66.4545 14.1332 66.4545 13.6005V9.51945C66.4545 7.8107 66.1871 6.63461 64.4682 6.63461C63.9324 6.63461 63.4857 6.70107 62.8841 6.9669C62.9509 7.36665 62.9955 7.8107 62.9955 8.29805V13.6015C62.9955 14.1342 63.196 14.4443 63.5303 14.6447C63.7318 14.7554 63.9547 14.8219 64.2444 14.8441V15.6647H57.4813V14.8441C57.771 14.8219 58.0171 14.7776 58.2177 14.6668C58.552 14.4896 58.7312 14.1342 58.7312 13.6015V9.51945C58.7312 7.8107 58.4638 6.63461 56.745 6.63461C56.2314 6.63461 55.7858 6.70107 55.2044 6.94475V13.6015C55.2064 14.1342 55.408 14.4453 55.7422 14.6447Z"
              fill="black"
            />
            <path
              d="M84.651 14.6447C84.7624 14.6668 84.8961 14.6447 85.0531 14.6447L85.0754 15.1552C84.4727 15.4875 83.2897 15.998 81.8169 15.998C79.7415 15.998 79.2949 15.0877 79.2949 13.8019V13.5572C78.5575 14.7997 77.419 15.9758 75.6343 15.9758C73.9377 15.9758 72.9552 14.9105 72.9552 13.3357C72.9552 11.2272 74.6964 10.5173 76.9733 10.0521L79.2949 9.5859V9.18616C79.2949 7.87716 78.8036 7.01221 77.1293 7.01221C76.2137 7.01221 74.8756 7.21158 73.3796 7.56702V5.99119C75.2767 4.97017 77.42 4.23814 79.228 4.23814C82.3973 4.23814 83.5581 5.96904 83.5581 8.92033V13.2692C83.5571 14.3567 83.8032 14.6447 84.651 14.6447ZM79.2938 13.0245V10.473L78.1331 10.762C77.3521 10.9614 76.7718 11.2947 76.7718 12.0931C76.7718 12.9581 77.4636 13.2471 78.1331 13.2471C78.5129 13.2471 78.914 13.1585 79.2938 13.0245Z"
              fill="black"
            />
            <path
              d="M86.0144 15.2216L85.9475 12.0267L86.8621 11.9159C87.6654 13.6468 88.8038 14.8008 90.3444 14.8008C91.4161 14.8008 92.0187 14.1795 92.0187 13.4475C92.0187 12.6711 91.2824 12.3378 90.3444 12.0941L89.3407 11.8273C87.8223 11.4276 86.1268 10.3632 86.1268 8.32121C86.1268 5.90258 88.4483 4.23814 91.6176 4.23814C92.8453 4.23814 94.2066 4.48282 95.2782 5.08194L95.501 7.92247L94.4294 7.98892C93.4479 6.0365 92.4209 5.43738 91.3269 5.43738C90.3677 5.43738 89.8755 6.0365 89.8755 6.74638C89.8755 7.61234 90.5227 8.01108 91.3938 8.23361L92.6214 8.54475C94.0941 8.92234 95.8799 9.67653 95.8799 11.8283C95.8799 14.7575 92.6437 16 89.9423 16C88.6489 15.998 87.1751 15.71 86.0144 15.2216Z"
              fill="black"
            />
            <path
              d="M99.2973 12.1485C98.2257 12.1485 97.0427 11.6159 97.0427 10.1296C97.0427 8.64242 98.2257 8.08861 99.2973 8.08861C100.346 8.08861 101.551 8.64342 101.551 10.1296C101.552 11.6159 100.347 12.1485 99.2973 12.1485Z"
              fill="black"
            />
            <path
              d="M2.10275 12.3821C1.03112 12.3821 0 11.8495 0 10.3632C0 8.87602 1.03112 8.32222 2.10275 8.32222C3.15109 8.32222 4.21665 8.87703 4.21665 10.3632C4.21665 11.8495 3.15109 12.3821 2.10275 12.3821Z"
              fill="black"
            />
          </svg>
        )}
        {type === 'kids' && (
          <svg xmlns="http://www.w3.org/2000/svg" width="109" height="28" viewBox="0 0 109 28" fill="none">
            <path
              d="M14.0008 0.525031C14.0008 0.238014 13.7628 0 13.4758 0C13.1888 0 12.9508 0.238014 12.9508 0.532032C12.9508 7.34343 7.34343 12.9508 0.532032 12.9508C0.238014 12.9508 0 13.1888 0 13.4758C0 13.7628 0.238014 14.0008 0.525031 14.0008H12.9508C13.5318 14.0008 14.0008 13.5318 14.0008 12.9508V0.525031Z"
              fill="black"
            />
            <path
              d="M27.4738 13.999H15.0481C14.4671 13.999 13.998 14.4681 13.998 15.0491V27.4748C13.998 27.7618 14.2361 27.9999 14.5231 27.9999C14.8101 27.9999 15.0481 27.7618 15.0481 27.4678C15.0481 20.6564 20.6554 15.0491 27.4668 15.0491C27.7539 15.0491 27.9989 14.8111 27.9989 14.5241C27.9989 14.237 27.7609 13.999 27.4738 13.999Z"
              fill="black"
            />
            <path d="M47.9342 8.99479V6.80273H40.0566V19.3893H42.3365V8.99479H47.9342Z" fill="black" />
            <path
              d="M55.8816 10.4444H53.7378L52.1215 16.9498H52.0875L50.2329 10.4444H48.0041L50.8492 18.874C51.0108 19.3529 51.069 19.9784 50.6348 20.2372C50.4662 20.3378 50.2504 20.3793 49.9437 20.3793C49.5694 20.3793 49.3312 20.3439 49.127 20.3086V22.2355C49.5013 22.3062 49.8586 22.3592 50.3691 22.3592C51.8663 22.3592 52.5809 21.8289 53.0573 20.1848L55.8816 10.4444Z"
              fill="black"
            />
            <path
              d="M64.9747 16.8614L63.2053 15.8891C62.882 16.7023 62.3546 17.6216 61.1125 17.6216C59.6663 17.6216 59.0028 16.3134 59.0028 14.9168C59.0028 13.5203 59.7514 12.2121 61.2316 12.2121C62.0483 12.2121 62.7799 12.7602 63.0521 13.644L64.8727 12.7778C64.3452 11.4343 63.3244 10.2322 61.2316 10.2322C58.4413 10.2322 56.825 12.2475 56.825 14.9168C56.825 17.5862 58.4413 19.6015 61.0785 19.6015C63.4094 19.6015 64.3963 18.1696 64.9747 16.8614Z"
              fill="black"
            />
            <path
              d="M73.9771 16.4371C73.9771 14.7047 72.735 13.5203 70.9826 13.5203H68.7367V10.4444H66.661V19.3893H70.8805C72.9392 19.3893 73.9771 18.1519 73.9771 16.4371ZM71.8163 16.3311C71.8163 17.2503 71.3909 17.5155 70.6593 17.5155H68.7367V15.3588H70.7104C71.51 15.3588 71.8163 15.73 71.8163 16.3311Z"
              fill="black"
            />
            <path d="M81.5198 12.3182V10.4444H75.803V19.3893H77.8788V12.3182H81.5198Z" fill="black" />
            <path
              d="M90.4097 10.4444H88.2659L86.6495 16.9498H86.6155L84.761 10.4444H82.5321L85.3772 18.874C85.5388 19.3529 85.5971 19.9784 85.1629 20.2372C84.9942 20.3378 84.7784 20.3793 84.4717 20.3793C84.0974 20.3793 83.8592 20.3439 83.6551 20.3086V22.2355C84.0294 22.3062 84.3867 22.3592 84.8971 22.3592C86.3943 22.3592 87.1089 21.8289 87.5853 20.1848L90.4097 10.4444Z"
              fill="black"
            />
            <path
              d="M99.5028 16.8614L97.7333 15.8891C97.41 16.7023 96.8826 17.6216 95.6406 17.6216C94.1944 17.6216 93.5308 16.3134 93.5308 14.9168C93.5308 13.5203 94.2794 12.2121 95.7597 12.2121C96.5764 12.2121 97.308 12.7602 97.5802 13.644L99.4007 12.7778C98.8733 11.4343 97.8524 10.2322 95.7597 10.2322C92.9694 10.2322 91.353 12.2475 91.353 14.9168C91.353 17.5862 92.9694 19.6015 95.6065 19.6015C97.9375 19.6015 98.9243 18.1696 99.5028 16.8614Z"
              fill="black"
            />
            <path
              d="M108.505 16.4371C108.505 14.7047 107.263 13.5203 105.511 13.5203H103.265V10.4444H101.189V19.3893H105.409C107.467 19.3893 108.505 18.1519 108.505 16.4371ZM106.344 16.3311C106.344 17.2503 105.919 17.5155 105.187 17.5155H103.265V15.3588H105.238C106.038 15.3588 106.344 15.73 106.344 16.3311Z"
              fill="black"
            />
          </svg>
        )}
      </div>
    )
  }

  function renderPrice() {
    if (lastPaymentProductDetails) {
      const periodLabel = isPaidTrialOrIntroductorySubscription ? null : get(lastPaymentProductDetails, 'title')
      const extraTipsLabel = extraTipCents ? `в том числе доплата ${extraTipCents / 100} ${currencySign}` : null
      return (
        <div className="account-subscription__info">
          {!isPaidTrialOrIntroductorySubscription && oldPrice !== effectivePrice && (
            <div className="account-subscription__old-price">{oldPrice}</div>
          )}
          <div className="account-subscription__price">{effectivePriceWithCurrency}</div>
          {Boolean(periodLabel) && <div className="account-subscription__period">{periodLabel}</div>}
          {Boolean(extraTipsLabel) && <div className="account-subscription__tips">{extraTipsLabel}</div>}
        </div>
      )
    }
    return null
  }

  function renderAttention() {
    if (
      (product === lastPaymentProduct && (Boolean(introductoryPriceCents) || priceCents !== nextPriceCents)) ||
      product !== lastPaymentProduct
    ) {
      return (
        <div className="account-subscription__wrap-attention">
          {renderAttentionText()}
          <Button onClick={handleSubscriptionManagementClick} isSubscription>
            Управление подпиской
          </Button>
        </div>
      )
    }
    return (
      <div className="account-subscription__wrap-button">
        <Button onClick={handleSubscriptionManagementClick} isSubscription>
          Управление подпиской
        </Button>
      </div>
    )
  }

  function renderAttentionText() {
    return (
      <>
        {/*Следущее списание будет по тому же плану, но по другой цене*/}
        {product === lastPaymentProduct && (Boolean(introductoryPriceCents) || priceCents !== nextPriceCents) && (
          <div className="account-subscription__attention">
            <strong>Внимание!</strong>{' '}
            {extraTipCents ? 'Следующее списание будет по цене ' : 'Следующее списание будет по стандарной цене '}
            <strong>
              {(nextPriceWithoutTipCents || 0) / 100} {currencySign}
              {Boolean(extraTipCents) &&
                ` + ${extraTipCents / 100} ${currencySign} = ${nextPriceCents / 100} ${currencySign}`}
            </strong>
          </div>
        )}
        {/*Следущее списание будет по другому плану*/}
        {product !== lastPaymentProduct && (
          <div className="account-subscription__attention">
            <strong>Внимание!</strong> Следующее списание будет по&nbsp;
            {product ? getAttentionText() : 'тарифу:'}{' '}
            <strong>
              {(nextPriceWithoutTipCents || 0) / 100} {currencySign}
              {Boolean(extraTipCents) &&
                ` + ${extraTipCents / 100} ${currencySign} = ${nextPriceCents / 100} ${currencySign}`}
            </strong>
          </div>
        )}
      </>
    )
  }

  function getAttentionText() {
    const lastPart = ' тарифу:'

    if (product.includes('lifetime')) {
      return 'тарифу Навсегда: '
    }

    if (product.includes('triennial')) {
      return 'трехгодовому' + lastPart
    }

    if (product.includes('yearly')) {
      return 'годовому' + lastPart
    }

    return 'месячному' + lastPart
  }

  function renderCancelSubscription() {
    return (
      <>
        {differentProducts && <div className="account-subscription__hr" />}
        <div className="account-subscription__description account-subscription__description--center">
          {/* Чтобы изменить платежные реквизиты, отмените текущую подписку и&nbsp;оформите другую с&nbsp;новыми данными.
              Обещаем, все получится!
              <br />
              <br /> */}
          Если вы&nbsp;отмените подписку сейчас, она продолжит действовать до&nbsp;{formattedExpiresAt}
          {Boolean(extraTipCents) && (
            <>
              <br />
              <br />С каждым платежом вы дополнительно помогаете Arzamas на {extraTipCents / 100} {currencySign},
              спасибо!
              <br />
              Скоро мы добавим возможность изменять эту сумму из личного кабинета, а пока можно написать{' '}
              <nobr>
                нам на <a href="mailto:radio@arzamas.academy">radio@arzamas.academy</a>
              </nobr>
              , если захотите это сделать.
            </>
          )}
        </div>
        <div className="account-subscription__wrap-button">
          <Button onClick={handleCancelClick} disabled={loading} isSubscription>
            {loading ? <Spinner /> : 'Отменить подписку'}
          </Button>
        </div>
      </>
    )
  }

  function renderAppleSubscription() {
    if (!Boolean(cancelledAt)) {
      return (
        <>
          <div className="account-subscription__description">
            По&nbsp;правилам компании Apple мы&nbsp;не&nbsp;можем управлять вашей подпиской.
            <br />
            Для этого вам нужно зайти в&nbsp;настройки своей учетной записи App Store и&nbsp;самостоятельно отменить там
            подписку или изменить платежные реквизиты.
            <br />
            <br />
            Если вы&nbsp;отмените подписку сейчас, она продолжит действовать до&nbsp;{formattedExpiresAt}
            {currency === 'RUB' && (
              <>
                <br />
                <br />
                Цена указана для российского магазина приложений App Store. Актуальную цену для вашей страны
                вы&nbsp;можете узнать в&nbsp;приложении.
              </>
            )}
          </div>
          <Button isSubscription component="a" href="https://support.apple.com/ru-ru/HT211011" target="_blank">
            Управление подпиской
          </Button>
        </>
      )
    }

    return null
  }

  function renderGoogleSubscription() {
    if (!Boolean(cancelledAt)) {
      return (
        <>
          <div className="account-subscription__description">
            По&nbsp;правилам компании Google мы&nbsp;не&nbsp;можем управлять вашей подпиской.
            <br />
            Для этого вам нужно зайти в&nbsp;настройки своей учетной записи Google Play и&nbsp;самостоятельно отменить
            там подписку или изменить платежные реквизиты.
            <br />
            <br />
            Если вы&nbsp;отмените подписку сейчас, она продолжит действовать до&nbsp;{formattedExpiresAt}
            {currency === 'RUB' && (
              <>
                <br />
                <br />
                Цена указана для российского магазина приложений Google Play. Актуальную цену для вашей страны
                вы&nbsp;можете узнать в&nbsp;приложении.
              </>
            )}
          </div>
          <Button
            isSubscription
            component="a"
            href="https://play.google.com/store/account/subscriptions"
            target="_blank">
            Управление подпиской
          </Button>
        </>
      )
    }

    return null
  }

  function renderDate() {
    return (
      <div
        className={classnames('account-subscription__data', {
          'account-subscription__data--right': kind !== 'apple_subscription' && kind !== 'google_subscription'
        })}>
        {Boolean(delayedDurationDays) && profile.subscriptions.length && type !== 'pack' ? (
          <span className="account-subscription__label">
            Заработает после
            <br />
            окончания подписки
          </span>
        ) : (
          <>
            <span className="account-subscription__label">
              {Boolean(cancelledAt) || kind === 'promo_subscription' ? 'Подписка заканчивается' : 'Следующее списание'}
            </span>
            <span className="account-subscription__value">{formattedExpiresAt}</span>
          </>
        )}
      </div>
    )
  }

  async function handleResumeCancelledClick() {
    setLoading(true)
    await patchSubscription(id, { resume_cancelled: true })
    setLoading(false)
  }

  function handleSubscriptionManagementClick() {
    setSubscriptionManagement(true)
  }

  function handleProductChange(selectedProduct) {
    setDifferentProducts(product !== selectedProduct)
    // setSelectedProduct(selectedProduct)
  }

  async function handleCancelClick() {
    setLoading(true)
    await patchSubscription(id, { cancel: true })
    setLoading(false)
    setSubscriptionManagement(false)
  }
}

const mapStateToProps = createStructuredSelector({
  profile: profileSelector,
  discounts: getDiscountsSelector
})

export default connect(mapStateToProps, { patchSubscription, setDiscounts })(Subscription)
